import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import { useProducts } from '../../hooks/useProducts';

const ServicosPage = () => {
  const { products, loading } = useProducts();

  if (loading) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600 font-poppins">Carregando produtos...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <WhatsAppButton />

      <section className="pt-32 pb-16 bg-gradient-to-br from-primary to-primary-dark text-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center">
            <h1 className="font-montserrat font-extrabold text-5xl md:text-6xl mb-6">
              Nossos Serviços
            </h1>
            <p className="text-xl font-poppins text-white/90 max-w-3xl mx-auto">
              Oferecemos uma linha completa de produtos personalizados com sublimação de alta qualidade.
            </p>
          </div>
        </div>
      </section>

      <section className="py-20 bg-gray-50" data-product-shop>
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          {products.length === 0 ? (
            <div className="text-center py-20">
              <p className="text-gray-600 font-poppins text-lg">
                Nenhum produto disponível no momento.
              </p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {products.map((service: any, index: number) => (
                <Link
                  key={service.slug || index}
                  to={`/servicos/${service.slug}`}
                  className="group cursor-pointer"
                >
                  <article className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 h-full flex flex-col">
                    <div className="relative h-64 overflow-hidden">
                      <img
                        src={service.image || ''}
                        alt={service.name || 'Produto'}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                      />
                    </div>

                    <div className="p-6 flex-1 flex flex-col">
                      <h2 className="font-montserrat font-bold text-2xl text-primary mb-3">
                        {service.name || 'Sem nome'}
                      </h2>

                      <p className="text-gray-600 font-poppins mb-4 flex-1">
                        {service.description || ''}
                      </p>

                      <ul className="space-y-2 mb-6">
                        {(service.features || []).slice(0, 3).map((feature: string, idx: number) => (
                          <li key={idx} className="flex items-center gap-2 text-sm text-gray-600">
                            <span>{feature}</span>
                          </li>
                        ))}
                      </ul>

                      <button className="w-full py-3 bg-accent-red text-white rounded-xl font-poppins font-medium">
                        Ver Detalhes
                      </button>
                    </div>
                  </article>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ServicosPage;